class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[action="/cart/add"]');
    if (!this.form || this.form.dataset.productFormBound === "true") {
      return;
    }

    this.form.dataset.productFormBound = "true";
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const submitButton = this.form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    try {
      const items = await this.buildItemsPayload(this.form);
      if (!items.length) {
        throw new Error("No variant ID found in form.");
      }

      if (
        !window.CartController ||
        typeof window.CartController.addItems !== "function"
      ) {
        throw new Error("CartController.addItems is not available.");
      }

      await window.CartController.addItems(items, true);

      await this.updateVariantButtonAvailability();
    } catch (error) {
      console.error("ProductForm.addToCart:", error);
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  }

  async buildItemsPayload(form) {
    const formData = new FormData(form);
    const variantId = formData.get("id");
    if (!variantId) {
      return [];
    }

    const quantity = Number.parseInt(formData.get("quantity") || "1", 10) || 1;
    const sellingPlan = formData.get("selling_plan");
    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.*)\]$/);
      if (!match || value === "") {
        continue;
      }

      properties[match[1]] = value;
    }

    const item = {
      id: variantId,
      quantity,
      properties,
    };

    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    const items = [item];

    if (
      window.CartController &&
      typeof window.CartController.appendTriggerGiftItems === "function"
    ) {
      // Reuse existing trigger-product logic from cart.js so qualifying gifts
      // are appended to this same add-to-cart request.
      await window.CartController.appendTriggerGiftItems(
        String(variantId),
        quantity,
        items
      );
    }

    return items;
  }

  async updateVariantButtonAvailability() {
    const variantButtons = document.querySelectorAll(".variant-button");
    if (!variantButtons.length) {
      return;
    }

    const response = await fetch("/cart.js");
    const cart = await response.json();

    variantButtons.forEach((button) => {
      const variantId = button.getAttribute("data-variant-id");
      const variantQuantity = Number.parseInt(
        button.getAttribute("data-variant-quantity") || "0",
        10
      );

      const cartItem = cart.items.find(
        (item) => String(item.variant_id) === String(variantId)
      );

      if (
        variantQuantity === 0 ||
        (cartItem && Number(cartItem.quantity) >= variantQuantity)
      ) {
        button.classList.add("disabled");
        button.setAttribute("disabled", "disabled");
      }
    });
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
